import { render } from "./RegistrationModal.vue?vue&type=template&id=bf1ea090&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import "./RegistrationModal.vue?vue&type=style&index=0&id=bf1ea090&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1ea090"]])

export default __exports__